import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import { Server, Cloud, Monitor, Wrench } from 'lucide-react';
import './DeploymentCard.css';

const STATUS_CONFIG = {
  online:   { label: 'Online',   cls: 'dep-card--online',   dot: '#3ecf8e' },
  degraded: { label: 'Degraded', cls: 'dep-card--degraded', dot: '#f5a623' },
  critical: { label: 'Critical', cls: 'dep-card--critical', dot: '#ff4f6b' },
  offline:  { label: 'Offline',  cls: 'dep-card--offline',  dot: '#ff4f6b' },
  unknown:  { label: 'Unknown',  cls: 'dep-card--unknown',  dot: '#4a5268' },
};

export default function DeploymentCard({ deployment: dep, onClick }) {
  const cfg = STATUS_CONFIG[dep.currentStatus] || STATUS_CONFIG.unknown;

  return (
    <div className={`dep-card ${cfg.cls} ${dep.maintenanceMode ? 'dep-card--maintenance' : ''}`} onClick={onClick}>
      <div className="dep-card__header">
        <div className="dep-card__icon">
          {dep.type === 'cloud' ? <Cloud size={16} /> : <Server size={16} />}
        </div>
        <div className="dep-card__title">
          <div className="dep-card__name">{dep.name}</div>
          <div className="dep-card__app">{dep.app?.name}</div>
        </div>
        <div className="dep-card__status">
          {dep.maintenanceMode
            ? <><Wrench size={12} /> <span>Maintenance</span></>
            : <><span className="dep-card__dot" style={{ background: cfg.dot }} /><span>{cfg.label}</span></>
          }
        </div>
      </div>

      <div className="dep-card__env-row">
        <span className={`env-badge env-badge--${dep.environment}`}>{dep.environment}</span>
        <span className="dep-card__type">{dep.type}</span>
      </div>

      <div className="dep-card__footer">
        {dep.lastHeartbeatAt
          ? <span>Last ping {formatDistanceToNow(new Date(dep.lastHeartbeatAt), { addSuffix: true })}</span>
          : <span className="text-muted">No heartbeat yet</span>
        }
      </div>
    </div>
  );
}
